import { Component, OnInit } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AbstractBiditComponent } from '../../shared/controls/abstract.bidit.component';
import { ExportService } from '../services/export.service';

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss']
})
export class ListComponent extends AbstractBiditComponent  {
  pageTitle: string = "Exports";

  constructor(private exportService: ExportService, deviceDetectorService: DeviceDetectorService) {
    super(deviceDetectorService);
  }

}
